module.exports = __webpack_public_path__ + "static/media/chart.bc251cac.png";